import {
  GET_VENDOR_PRICING_PROFILE,
  GET_VENDOR_PRICING_PROFILE_FAIL,
  GET_VENDOR_PRICING_PROFILE_SUCCESS,
  GET_VENDOR_PRICING,
  GET_VENDOR_PRICING_FAIL,
  GET_VENDOR_PRICING_SUCCESS,
  ADD_NEW_VENDOR_PRICING,
  ADD_VENDOR_PRICING_SUCCESS,
  ADD_VENDOR_PRICING_FAIL,
  UPDATE_VENDOR_PRICING,
  UPDATE_VENDOR_PRICING_SUCCESS,
  UPDATE_VENDOR_PRICING_FAIL,
  DELETE_VENDOR_PRICING,
  DELETE_VENDOR_PRICING_SUCCESS,
  DELETE_VENDOR_PRICING_FAIL,
} from "./actionTypes"

export const getVendor_pricing = ({id,offset='',page_size=''}) => ({
  type: GET_VENDOR_PRICING,
  payload:{id,offset,page_size}
})

export const getVendor_pricingSuccess = Vendor_pricing => ({
  type: GET_VENDOR_PRICING_SUCCESS,
  payload: Vendor_pricing,
})

export const getVendor_pricingFail = error => ({
  type: GET_VENDOR_PRICING_FAIL,
  payload: error,
})

export const addNewVendor_pricing = (user,history) => ({
  type: ADD_NEW_VENDOR_PRICING,
  payload: {user,history},
})

export const addVendor_pricingSuccess = user => ({
  type: ADD_VENDOR_PRICING_SUCCESS,
  payload: user,
})  

export const addVendor_pricingFail = error => ({
  type: ADD_VENDOR_PRICING_FAIL,
  payload: error,
})

export const updateVendor_pricing = (user, history) => ({
  type: UPDATE_VENDOR_PRICING,
  payload: { user, history },
})

export const updateVendor_pricingSuccess = user => ({
  type: UPDATE_VENDOR_PRICING_SUCCESS,
  payload: user,
})

export const updateVendor_pricingFail = error => ({
  type: UPDATE_VENDOR_PRICING_FAIL,
  payload: error,
})

export const deleteVendor_pricing = user => ({
  type: DELETE_VENDOR_PRICING,
  payload: user,
})

export const deleteVendor_pricingSuccess = user => ({
  type: DELETE_VENDOR_PRICING_SUCCESS,
  payload: user,
})

export const deleteVendor_pricingFail = error => ({
  type: DELETE_VENDOR_PRICING_FAIL,
  payload: error,
})

export const getVendor_pricingProfile = () => ({
  type: GET_VENDOR_PRICING_PROFILE,
})

export const getVendor_pricingProfileSuccess = userProfile => ({
  type: GET_VENDOR_PRICING_PROFILE_SUCCESS,
  payload: userProfile,
})

export const getVendor_pricingProfileFail = error => ({
  type: GET_VENDOR_PRICING_PROFILE_FAIL,
  payload: error,
})
